import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Table from './common/table';
import auth from '../services/authService';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class BitcoinWalletTypesTable extends Component {
  columns = [
    {
      path: 'name',
      label: 'Name'
    },
    {
      path: 'exchange_rate',
      label: 'Exchange Rate'
    },
    {
      path: 'created_at',
      label: 'Created Date',
      content: bwallet =>
        moment(bwallet.created_at)
          .startOf('day')
          .format('LL')
    },
    {
      key: bwallet => `${bwallet._id}-s`,
      label: 'Info',
      content: bwallet => (
        <Link
          to={`/bwallet-types/${bwallet._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      )
    }
  ];

  deleteColumn = {
    key: 'delete',
    label: 'Delete',
    content: bwallet => (
      <button
        onClick={() => this.props.onDelete(bwallet)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    )
  };

  editColumn = {
    key: 'edit',
    label: 'Edit',
    content: bwallet => (
      <Link
        to={`/bwallet-types/edit/${bwallet._id}`}
        className="btn btn-custom btn-sm"
      >
        Edit
      </Link>
    )
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      this.columns.push(this.editColumn);
      this.columns.push(this.deleteColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function() {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { bwtypes, message } = this.props;
    return (
      <Table columns={this.columns} data={bwtypes} message={message} />
    );
  }
}

export default BitcoinWalletTypesTable;
